import { graphql } from 'react-apollo';
import { AllEligibleCountries } from '../../queries/AllEligibleCountries';
import { createOptions } from "../../utils/createOptions";

const withEligibleCountriesOptions = graphql(AllEligibleCountries, {
  options: () => ({ fetchPolicy: 'cache-first' }),
  props: ({ data: { allEligibleCountries, loading, error } }) => ({
    error,
    loading,
    eligibleCountriesOptions: allEligibleCountries
      ? createOptions(allEligibleCountries, 'id', 'name')
      : []
  })
});

export default withEligibleCountriesOptions;



// WEBPACK FOOTER //
// ./src/component/HOC/withEligibleCountriesOptions.js